import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocalStorageService } from '@services/local-storage.service';
import { StoreInitializationService } from '@services/store-initialization.service';
import { map, Observable, switchMap, take, tap } from 'rxjs';
import { activeClientActions } from 'src/app/shared/store/active-client/active-client.actions';
import { CLIENT_CODE_STORAGE_KEY } from 'src/app/shared/store/active-client/client-code-storage.key';
import { pickClientCode } from 'src/app/shared/utils/pick-client-code.utils';
import { selectReadAccessClientCodes } from 'src/app/shared/store/licenses/licenses.selectors';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ClientCodeService {
  private readonly store = inject(Store);
  private readonly localStorage = inject(LocalStorageService);
  private readonly storeInitializationService = inject(StoreInitializationService);

  resolveClientCode(requestedClientCode?: string): Observable<string | null> {
    return this.storeInitializationService.ensureInitialized().pipe(
      switchMap(() => this.store.select(selectReadAccessClientCodes).pipe(take(1))),
      map((readAccessClientCodes) =>
        pickClientCode(
          readAccessClientCodes,
          this.localStorage.get(CLIENT_CODE_STORAGE_KEY),
          environment.commonClientCode,
          requestedClientCode,
        ),
      ),
    );
  }

  switchTo(requestedClientCode: string): Observable<string | null> {
    return this.resolveClientCode(requestedClientCode).pipe(
      tap((clientCode) => {
        if (clientCode) {
          this.store.dispatch(activeClientActions.setActiveClient({ clientCode }));
        }
      }),
    );
  }
}
